<template>
  <div class="loading">
    <div class="text text-xs-center">
      <v-progress-circular class="mx-auto" :size="70" color="white" indeterminate />
      <div class="headline mt-3">Loading...</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
}
</script>

<style scoped>
  .loading {
    position: fixed;
    top: 0;
    right: 0;
    max-width: 100% !important;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 15000;
  }
  .text {
    position: absolute;
    top: 50%;
    left: 50%;
    color: #FFFFFF;
  }
</style>
